import {
  createUserWithEmailAndPassword, GoogleAuthProvider, OAuthProvider,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  validatePassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";

export const settingsToLoad = [
  'BookNow.AllowKidOnlyRooms',
];

export const buildValidatePayload = (loyaltyNo, surname) => {
  return {
    messageType: 'Validate',
    loyaltyNo, surname
  }
};

export const processValidateRS = (data) => {
  return data.profile;
};

export const getSinglePropertyId = (site) => {
  if(site) {
    const {propertyIds} = site;
    return propertyIds[0]
  }
}

export const handlePasswordAuth = (auth, email, password, signInSuccessCallback,
    setResendEmail, setBusy, setError) => {

  setBusy(true)
  setError(undefined);

  signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    const user = userCredential.user;

    if(user.emailVerified) {
      userCredential.user.getIdToken(false).then((accessToken) => {
        signInSuccessCallback(user.email, accessToken)
      });
    }
     else {
       signOut(auth).then(() => {
         console.log('Signed out.')
       })
       setError('Please verify your e-mail address by clicking the link that was sent to you. Or try and resend it.');
       setResendEmail(true);
    }

  })
  .catch((error) => {
    console.error('error', error)
    const errorCode = error.code;

    setError(getErrorMessage(errorCode));

  }).finally(() => {
    setBusy(false);
  });

}

export const handlePasswordSignUp = (auth, email, password, setInviteEmailSent,
    setBusy, setError) => {
  setBusy(true)
  setError(undefined)

  validatePassword(auth, password).then(status => {
    if (status.isValid) {

      createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;

        const actionCodeSettings = {
          url: window.location.href.substring(0, window.location.href.indexOf('/contactinvite')),
        };

         sendEmailVerification(user, actionCodeSettings).then(() => {
               console.log('Email verification sent.')
               setInviteEmailSent(true);
             }
         )

      })
      .catch((error) => {
        const errorCode = error.code;
        console.error('error', error)

        setError(getErrorMessage(errorCode));

      }).finally(() => {
        setBusy(false);
      });
    }
  });

}

export const handleResendEmail = (auth, email, password, setResendEmail,
    setInviteEmailSent, setBusy, setError) => {

  setBusy(true)
  setError(undefined);

  signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    const user = userCredential.user;

    const url = window.location.href.indexOf('/contactinvite') > 0
        ? window.location.href.substring(0,
            window.location.href.indexOf('/contactinvite'))
        : window.location.href;

    const actionCodeSettings = {
      url
    };

    sendEmailVerification(user, actionCodeSettings).then(() => {
          console.log('Email verification sent.')
          setInviteEmailSent(true);
          setResendEmail(false);
        }
    )

  })
  .catch((error) => {
    console.error('error', error)
    const errorCode = error.code;

    setError(getErrorMessage(errorCode));

  }).finally(() => {
    setBusy(false);
  });

}

export const handleGoogleAuth = (auth, signInSuccessCallback, setBusy, setError) => {
  const provider = new GoogleAuthProvider();

  setBusy(true);
  setError(undefined);

  signInWithPopup(auth, provider)
  .then((result) => {
    const user = result.user;

    user.getIdToken().then(accessToken => {
      signInSuccessCallback(user.email, accessToken)
    });

  }).catch((error) => {
    const errorCode = error.code;

    setError(getErrorMessage(errorCode));
  }).finally(() => {
    setBusy(false);
  });
}

export const handleMicrosoftAuth = (auth, signInSuccessCallback, setBusy, setError) => {
  const provider = new OAuthProvider('microsoft.com');

  signInWithPopup(auth, provider)
  .then((result) => {
    const user = result.user;

    // Get the OAuth access token and ID Token
    // const credential = OAuthProvider.credentialFromResult(result);
    // const accessToken = credential.accessToken;
    // const idToken = credential.idToken;

    user.getIdToken().then(accessToken => {
      signInSuccessCallback(user.email, accessToken)
    });

  }).catch((error) => {
    const errorCode = error.code;

    setError(getErrorMessage(errorCode));
  }).finally(() => {
    setBusy(false);
  });
}

export const handleAppleAuth = (auth, signInSuccessCallback, setBusy, setError) => {
  const provider = new OAuthProvider('apple.com');

  setBusy(true);
  setError(undefined);

  signInWithPopup(auth, provider)
  .then((result) => {
    // The signed-in user info.
    const user = result.user;

    // Apple credential
    // const credential = OAuthProvider.credentialFromResult(result);
    // const accessToken = credential.accessToken;
    // const idToken = credential.idToken;

    user.getIdToken().then(accessToken => {
      signInSuccessCallback(user.email, accessToken)
    });
  })
  .catch((error) => {
    const errorCode = error.code;

    setError(getErrorMessage(errorCode));
  }).finally(() => {
    setBusy(false);
  });
}

export const handleForgotPassword = (auth, email, setEmailSent, setBusy, setError) => {
  setBusy(true);
  setError(undefined);

  const actionCodeSettings = {
    url: window.location.href,
  };

  sendPasswordResetEmail(auth, email, actionCodeSettings)
  .then(() => {
    setEmailSent(true);
  })
  .catch((error) => {
    const errorCode = error.code;

    console.error('error', error)

    setError(getErrorMessage(errorCode));
  }).finally(() => {
    setBusy(false);
  });

}

export const getErrorMessage = (code) => {
  switch (code) {
    case 'auth/invalid-credential' :
      return 'Invalid email or password.';

    case 'auth/wrong-password' :
      return 'Invalid email or password.';

    case 'auth/email-already-in-use' :
      return 'Email already in use.';

    case 'auth/credential-already-in-use' :
      return 'Credentials already in use.';

    case 'auth/account-exists-with-different-credential' :
      return 'Account already exists with different credentials.';

    case 'auth/invalid-email' :
      return 'Invalid e-mail address.';

    case 'auth/user-not-found' :
      return 'User not found.';

    default :
      return 'An error occurred. Please contact support.'
  }

}

export const isErrorAuthResponse = (data) => {
  return data.errors && data.errors.length > 0;
};

export const processAuthErrorRS = (data) => {
  const error = data.errors[0];
  const {errorType} = error;

  switch (errorType) {
    case 'USERNAME_NOT_FOUND' : return 'We couldn’t find an account with that email.';
    case 'MODULE_ACCESS_REQUIRED' : return 'Module access denied.'

    default :
      return 'An error occurred. Please contact support.'
  }
};

export const buildPasswordRestrictions = (passwordPolicy) => {
  let passwordRestrictions = [
    { id: 'minPasswordLength',
      name: 'Minimum password length.',
      value: passwordPolicy.customStrengthOptions.minPasswordLength}
  ];

  if(passwordPolicy.customStrengthOptions.containsLowercaseLetter) {
    passwordRestrictions.push(
        {id: 'containsLowercaseLetter'}
    )
  }

  if(passwordPolicy.customStrengthOptions.containsUppercaseLetter) {
    passwordRestrictions.push(
        {id: 'containsUppercaseLetter'}
    )
  }

  if(passwordPolicy.customStrengthOptions.containsNumericCharacter) {
    passwordRestrictions.push(
        {id: 'containsNumericCharacter'}
    )
  }

  if(passwordPolicy.customStrengthOptions.containsNonAlphanumericCharacter) {
    passwordRestrictions.push(
        {id: 'containsNonAlphanumericCharacter', value: passwordPolicy.allowedNonAlphanumericCharacters}
    )
  }

  return passwordRestrictions;
}

export const getRestrictionName = (restriction) => {
  const {id, value} = restriction;

  switch (id) {

    case 'minPasswordLength' :
      return "Length between "+value+" and 50 characters.";

    case 'containsLowercaseLetter':
      return "Minimum of one lowercase character. (a-z)"

    case 'containsUppercaseLetter':
      return "Minimum of one uppercase character. (A-Z)"

    case 'containsNumericCharacter' :
      return "Minimum of one Number (0-9)."

    case 'containsNonAlphanumericCharacter' :
      return "Minimum of one Special character: "+value;

    default: return "Unknown";
  }
}

export const getValidationFn = (restriction) => {
  switch (restriction.id) {
    case 'minPasswordLength' :
      return (restriction, password) => { // password length
        return password.length >= Number.parseInt(restriction.value)
            && password.length <= 50;
      }

    case 'containsLowercaseLetter' :
      return (restriction, password) => { // lowercase
        const regex = /([a-z])/
        return regex.test(password);
      }

    case 'containsUppercaseLetter' :
      return (restriction, password) => { // uppercase
        const regex = /([a-z].*[A-Z]|[A-Z].*[a-z])/
        return regex.test(password);
      }

    case 'containsNumericCharacter' :
      return (restriction, password) => { // numeric
        const regex = /[0-9]/
        return regex.test(password);
      }

    case 'containsNonAlphanumericCharacter' :
      return (restriction, password) => { // special characters
        const regex = /[$^*.\[\]{}()?"!@#%&/\\,><':;|_~-]/;
        return regex.test(password);
      }

    default :
      return () => {
        return false;
      }
  }
}